import Axios from "../../src/helpers/axios";

export const getAllCategories = () => {
  return Axios.get("/api/ecommerce/v1/categories/all");
};
